module.exports = __webpack_public_path__ + "img/image003.ff02ef52.jpg";